import React from 'react';
import { get } from 'lodash';
import RenderSource from './RenderSource';
import RenderViewerId from './RenderViewerId';
import RenderViewerSession from './RenderViewerSession';

interface IProps {
  column: {
    dataKey: string;
  };
  cellData: any;
  rowData: {
    [k: string]: any;
  };
  columns: any[];
}

const CustomCell = (cellProps: IProps) => {
  const {
    column: { dataKey },
    cellData,
    rowData,
    columns,
  } = cellProps;
  const { ViewerId = null } = rowData;
  const { ClientId, SessionId, SessionStartTime } = rowData;

  const summaries = columns.map(item => item.dataKey);

  const renderers = {
    ViewerId: <RenderViewerId data={cellData} />,
    SessionId: (
      <RenderViewerSession
        sessionId={SessionId}
        clientId={ClientId}
        sessionStartTime={SessionStartTime}
        dataKey={dataKey}
        viewerId={ViewerId}
        summaries={summaries}
      />
    ),
  };

  const renderer = get(
    renderers,
    [dataKey],
    <RenderSource data={cellData} dataKey={dataKey} />,
  );
  return renderer;
};

export default CustomCell;
